export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-adobe-2651f00a04c0b94d7afd6b3041d55baa.svg";